import React from "react";
import { Modal } from "react-rainbow-components";
import styled from "styled-components";
interface IProps {
  showErr: boolean;
  setShowErr: (val: boolean) => void;
  error: string;
}

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 0 2rem;
`;

export const ButtonCreateAdmin = styled.div`
  cursor: pointer;
  padding: 0.5rem 2rem;
  border-radius: 999rem;
  background-color: #4779f4;
  color: #fff;
`;

export const ModalErr = styled(Modal)`
  z-index: 9999 !important;
`;
export default function ModalError(props: IProps) {
  return (
    <ModalErr
      isOpen={props.showErr}
      onRequestClose={() => props.setShowErr(false)}
      hideCloseButton
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          paddingTop: "1rem",
        }}
      >
        <p>{props.error}</p>
        <ButtonContainer>
          <ButtonCreateAdmin onClick={() => props.setShowErr(false)}>
            ตกลง
          </ButtonCreateAdmin>
        </ButtonContainer>
      </div>
    </ModalErr>
  );
}
